import React from 'react';
import "../LoadingAnimation.css";

const LoadingAnimation = () => {
    return (
        <div className="flex text-center items-center justify-center min-h-screen bg-gray-900 absolute inset-0 z-50">
            <div className="morph-animation-container">
                
                {/* Şekil 1 */}
                <svg
                    className="morph-shape shape-1 text-blue-500"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#288eff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                </svg>

                {/* Şekil 2 */}
                <svg
                    className="morph-shape shape-2 text-green-500"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#288eff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z" />
                    <circle cx="12" cy="10" r="3" />
                </svg>

                {/* Şekil 3 */}
                <svg
                    className="morph-shape shape-3 text-green-500"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#288eff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <g transform="translate(2 3)">
                        <path d="M20 16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3l2-3h6l2 3h3a2 2 0 0 1 2 2v11z" />
                        <circle cx="10" cy="10" r="4" />
                    </g>
                </svg>

            </div>

            <p className="mt-6 text-center text-gray-300 text-lg italic animate-pulse">
                Birazdan geçmişle tanışacaksın...
            </p>
        </div>
    );
};

export default LoadingAnimation;